function initPhoneMask(index, node) {
    var maskList = $.masksSort($.masksLoad("/front-libs/js/phone-codes.json"), ['#'], /[0-9]|#/, "mask");
    var maskOpts = {
        inputmask: {
            definitions: {
                '#': {
                    validator: "[0-9]",
                    cardinality: 1
                }
            },
            showMaskOnHover: false,
            autoUnmask: true
        },
        match: /[0-9]/,
        replace: '#',
        list: maskList,
        listKey: "mask"
    };
    $(node).inputmasks(maskOpts);
    $(node).addClass('_mask-init');
}

function initDateMask(index, node) {
    let minDate = new Date();
    minDate.setFullYear((new Date).getFullYear() - 100);
    let minDateStr = "";
    minDateStr += minDate.getDate() >= 10 ? `${minDate.getDate()}.` : `0${minDate.getDate()}.`;
    minDateStr += (minDate.getMonth() + 1 >= 10) ? `${minDate.getMonth() + 1}` : `0${minDate.getMonth() + 1}.`;
    minDateStr += `${minDate.getFullYear()}`

    $(node).inputmask("datetime",{
        inputFormat: 'dd.mm.yyyy',
        placeholder: '__.__.____',
        clearIncomplete: true,
        min: minDateStr
    });
}

let IMaskFields = new Map();
function initMask(index, node) {
    let maskedField = IMask($(node)[0], {
        mask: $(node).attr('data-mask'),
        lazy: false,
        placeholderChar: '_',
    });

    $(node).addClass('_mask-init');
    IMaskFields.set(node.name, maskedField);
}

$(function () {


    App.Mask = {
        init: function () {

            $(".js--phone-mask:not(._mask-init)").each(initPhoneMask);
            $(".js--date-mask:not(._mask-init)").each(initDateMask);

            $('.js--email-mask:not(._mask-init)').each(function () {
                $(this).inputmask({
                    mask: "*{1,20}[.*{1,20}][.*{1,20}][.*{1,20}]@*{1,20}[.*{2,6}][.*{1,2}]",
                    greedy: false,
                    onBeforePaste: function (pastedValue, opts) {
                        pastedValue = pastedValue.toLowerCase();
                        return pastedValue.replace("mailto:", "");
                    },
                    definitions: {
                        '*': {
                            validator: "[0-9A-Za-z!#$%&'*+/=?^_`{|}~\-]",
                            casing: "lower"
                        }
                    }
                });
                $(this).addClass('_mask-init');
            });

            $('[data-mask]:not(._mask-init)').each(initMask);

            $('[data-mask-zp]:not(._mask-init)').each(function () {

                IMask($(this)[0], {
                    mask: /^\d{1,9}$/,
                    lazy: false,
                    placeholderChar: '_'
                });

                $(this).addClass('_mask-init');

            });

        }
    };
    App.Mask.init();

});

$(function () {

    App.AjaxFormSend = function (opt) {

        let $form = opt.form;

        App.ajaxPreloader.start();

        let formData = new FormData($form[0]);

        $($form[0]).find('[data-mask]').each(function (index, node) {
            let name = node.name;
            let imask = IMaskFields.get(name);
            if (imask) {
                let unmaskedValue = imask.unmaskedValue;
                // ToDo bad
                if (!unmaskedValue || name === 'military_specialty') {
                    formData.set(name, unmaskedValue);
                }
            }
        });

        $.ajax({
            url: $form.attr('action'),
            type: $form.attr('method'),
            data: formData,
            processData: false,
            contentType: false,
            success: function (data) {
                App.ajaxPreloader.stop();
                try {

                    $('.form-item', $form).removeClass('_error');
                    $('.js--form-item', $form).removeClass('_error');

                    let request = JSON.parse(data);

                    switch (request.STATUS) {
                        case 'ERROR':

                            App.Popup.openPopupSuccess({
                                title: request.ERROR_TITLE,
                                text: request.ERROR_TEXT
                            });

                            for (let key in request.ERRORS) {

                                let $input = $('[name="' + key + '"]', $form),
                                    $inputContainer = $input.closest('.form-item');
                                if (!$inputContainer.length)
                                    $inputContainer = $input.closest('.js--form-item');
                                let $errorText = $inputContainer.find('.form-item__error');
                                if (!$errorText.length)
                                    $errorText = $inputContainer.find('.js--form-item-error');
                                let label = $inputContainer.find('.form-item__label');
                                let labelText = label.text();

                                $errorText.text(request.ERRORS[key]);
                                $inputContainer.addClass('_error');

                            }

                            if (request.UPDATE_CAPTCHA == 'yes') {
                                $('[name=captcha_sid]', $form).val(request.CAPTCHA__DATA.captcha_sid);
                                $('[name=captcha_word]', $form).val('');
                                $(document).trigger('toggleLabel');
                                $('.js--webform-captcha-img', $form).attr('src', request.CAPTCHA__DATA.src);
                            }

                            let $firstError = $('.form-item._error', $form).first();
                            $('input', $firstError).focus();

                            if ($form.innerHeight() > $(window).height()) {
                                $('html, body').animate({'scrollTop': $firstError.offset().top - 150}, 1);
                            }

                            break;
                        case 'OK':

                            opt.callback(request);

                            break;
                    }

                } catch (err) {
                    console.log(err);
                }

            }

        });

    };

    $(document).on('submit', '.js--webform', function (e) {
        e.preventDefault();
        let $form = $(this);

        App.AjaxFormSend({
            form: $form,
            callback: function (request) {

                App.Popup.openPopupSuccess({
                    title: request.SUCCESS_TITLE,
                    text: request.SUCCESS_TEXT
                });

                $('input[type=text]', $form).val('');
                $('input[type=tel]', $form).val('');
                $('input[type=email]', $form).val('');
                $('textarea', $form).val('');
                $('select', $form).val('');

                if (request.SUCCESS_URL != undefined) {
                    setTimeout(function () {
                        location.href = request.SUCCESS_URL;
                    }, 2000);
                }

                if (request.SUCCESS_RELOAD != undefined) {
                    setTimeout(function () {
                        location.reload();
                    }, 2000);
                }

                App.Seo.send('formSend', request.WEBFORM_SID);

            }
        });

    });

});

$(function () {

    App.ToggleLabels = {

        init: function () {

            function toggleLabel($input) {

                if ($input.attr('type') == 'checkbox'
                    || $input.attr('type') == 'radio'
                    || $input.hasClass('select2-search__field')
                ) return;

                let val = $input.val(),
                    $formItem = $input.closest('.form-item');

                let placeholder = $input.attr('placeholder'),
                    isPlaceholder = (placeholder != undefined && placeholder != '');

                if (val != '' || isPlaceholder)
                    $formItem.addClass('_not-empty');
                else
                    $formItem.removeClass('_not-empty');

            }

            $(document).on('blur', 'input, textarea', function () {
                toggleLabel($(this));
            });
            $(document).on('focus', 'input, textarea', function () {
                $(this).closest('.form-item').addClass('_not-empty');
            });
            $(document).on('change', 'select', function () {
                toggleLabel($(this));
            });

            $(document).on('toggleLabel', function () {
                $('input, textarea, select').each(function () {
                    toggleLabel($(this));
                });
            });
            $(document).trigger('toggleLabel');

        }

    };
    App.ToggleLabels.init();

});